import { render, staticRenderFns } from "./LeadExtra.vue?vue&type=template&id=5232c926"
import script from "./LeadExtra.vue?vue&type=script&lang=js"
export * from "./LeadExtra.vue?vue&type=script&lang=js"
import style0 from "./LeadExtra.vue?vue&type=style&index=0&id=5232c926&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports